import { numberOptionalSchema, select2OptionalSchema, select2RequiredSchema, statusSchema, stringOptionalSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { object } from 'yup';

const addTemplateSchema = object().shape({

   
    template_desc: stringRequiredSchema,
    email_status: stringRequiredSchema,
    firebase_heading: stringRequiredSchema,
    firebase_content: stringRequiredSchema,
    firebase_status: select2RequiredSchema,
});

export default addTemplateSchema;